
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


const timelineWrapper = document.getElementById('timeline-section');

if (timelineWrapper) {
    function updateTimelineAnimation() {
        const timeline = document.querySelector('.timeline');
        const timelineItems = timeline.querySelectorAll('.timeline-item');
        const timelineItemsLength = timelineItems.length;
        const timelineItemsWidth = timelineItemsLength * 400;

        gsap.timeline()
            .clear()
            .to(timeline, {
                x: () => `-${timelineItemsWidth - timeline.offsetWidth}`,
                scrollTrigger: {
                    trigger: timelineWrapper,
                    start: 'center center',
                    end: () => `+=${timeline.offsetWidth} top`,
                    pin: true,
                    scrub: 0.25,
                    invalidateOnRefresh: true
                }
            });
    }

    updateTimelineAnimation();
}